'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';

import 'angular-socket-io';
import angularFileUpload from 'angular-file-upload';
import ngclipboard from 'ngclipboard';

import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';

import {
    routeConfig
} from './app.config';

import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import main from './main/main.component';
import user from './user/user.component';
import search from './search/search.component';
import survey from './survey/survey.component';
import feedback from './feedback/feedback.component';
import multiplication from './multiplication/multiplication.component';
import notebook from './notebook/notebook.component';
import highlight from './highlight/highlight.component';
import mark from './mark/mark.component';
import order from './order/order.component';
import speechtype from './speechtype/speechtype.component';
import speechprofile from './speechprofile/speechprofile.component';
import speechdetails from './speechdetails/speechdetails.component';
import paysub from './paysub/paysub.component';
import adsub from './adsub/adsub.component';
import sharelink from './sharelink/sharelink.component';
import pushtoken from './pushtoken/pushtoken.component';
import custom from './custom/custom.component';
import oneday from './oneday/oneday.component';
import speechtype_en from './speechtypeen/speechtypeen.component';
import speechprofile_en from './speechprofileen/speechprofileen.component';
import speechdetails_en from './speechdetailsen/speechdetailsen.component';
import speechtype_es from './speechtypees/speechtypees.component';
import speechprofile_es from './speechprofilees/speechprofilees.component';
import speechdetails_es from './speechdetailses/speechdetailses.component';
import news from './new/new.component';
import setpoint from './setpoint/setpoint.component';
import iosdata from './iosdata/iosdata.component';
import shareimg from './shareimg/shareimg.component';
import plantype from './plantype/plantype.component';
import planstatus from './planstatus/planstatus.component';
import admanage from './admanage/admanage.component';
import emaileditor from './emaileditor/emaileditor.component';
import stories from './story/story.component';
import adDefaults from './adDefaults/adDefaults.component';
import adDefaultsVideo from './adDefaultsVideo/adDefaults.component';
import adDefaultStat from './adDefaultStat/adDefaultStat.component';
import AdAggregationComponent from './ad-aggregation/ad-aggregation.component';
import QuizComponent from './quiz/quiz.component';


import constants from './app.constants';
import util from '../components/util/util.module';
import socket from '../components/socket/socket.service';
import StoryStatComponent from './storyStat/storyStat.component';
import AppSwitchComponent from './app-switch/app-switch.component';
import CommonImagesCenterComponent from './common-images-center/common-images-center.component';
import complaint from './complaint/complaint.component';
import UbaComponent from './uba/uba.component';

import './app.less';

angular.module('tttApp', [ngCookies, ngResource, ngSanitize, 'btford.socket-io', 'ng.ueditor', uiRouter,
    uiBootstrap, navbar, footer, main, user, search, survey,
    feedback, multiplication, notebook, highlight, mark,
    order, speechtype, speechprofile, speechdetails, paysub,
    adsub, sharelink, pushtoken, custom, oneday, speechtype_en,
    speechtype_es, speechprofile_en, speechprofile_es,
    speechdetails_en, speechdetails_es, news, setpoint, iosdata,
    shareimg, plantype, planstatus, admanage, emaileditor, constants,
    socket, util, 'angularFileUpload',

    stories, adDefaults, StoryStatComponent, AdAggregationComponent,
    QuizComponent, AppSwitchComponent, CommonImagesCenterComponent, 'ngclipboard',
    complaint, adDefaultStat, adDefaultsVideo, UbaComponent
])
    .config(routeConfig)
    .run(function($rootScope, $cookies, $http, $window, $interval, $location) {
        'ngInject';

        $rootScope.$on('$stateChangeStart', function(evt, next, current) {
            if($cookies.get('token')) {
                $rootScope.islogin = true;
            } else {
                $rootScope.islogin = false;
                $location.path('main');
            }

            console.log($rootScope.islogin);
        });
        $rootScope.$on('$stateChangeSuccess', function(evt, current, previous) {
            console.log('route have already changed ：' + $location.path());
        });


    });

angular.element(document)
    .ready(() => {
        angular.bootstrap(document, ['tttApp'], {
            strictDi: true
        });
    });



// WEBPACK FOOTER //
// ./client/app/app.js